import 'element-closest';

window.addEventListener('DOMContentLoaded', function () {
    let membershipContainerTabsNodeList = document.querySelectorAll('.membership-container-tab-js');
    let membershipContainerTabsArray = Array.prototype.slice.call(membershipContainerTabsNodeList);

    let membershipLevelsNodeList = document.querySelectorAll('.membership-level-js');
    let membershipLevelsArray = Array.prototype.slice.call(membershipLevelsNodeList);

    let membershipPageTabsNodeList = document.querySelectorAll('.membership-page-tab-js');
    let membershipPageTabsArray = Array.prototype.slice.call(membershipPageTabsNodeList);

    let membershipContainersNodeList = document.querySelectorAll('.membership-container-js');
    let membershipContainersArray = Array.prototype.slice.call(membershipContainersNodeList);

    let membershipSectionsNodeList = document.querySelectorAll('.membership-page-container-js');
    let membershipSectionsArray = Array.prototype.slice.call(membershipSectionsNodeList);

    isMobile();

    membershipSectionsArray.forEach(function (section) {
        let activeTab = section.querySelector('.membership-page-tab-js');

        activeTab.classList.add('active');
        activeTab.parentElement.classList.add('active');

        let activeContainerTabId = section.querySelector('.membership-page-tab-js.active').getAttribute('id').replace('membershipPageTab', '');

        section.querySelector('#membershipContainer' + activeContainerTabId).classList.add('active');
    }) 

    membershipPageTabsArray.forEach(function (tab) {
        tab.addEventListener('click', function () {
            let currentMembershipSection = tab.closest('.membership-page-container-js');

            if (!(tab.classList.contains('active'))) {
                membershipPageTabsArray.forEach(function (tab) {
                    if (currentMembershipSection.querySelector('#' + tab.id)) {
                        currentMembershipSection.querySelector('#' + tab.id).classList.remove('active');   
                    }               
                })

                tab.classList.add('active');

                membershipContainersArray.forEach(function (container) {
                    if (currentMembershipSection.querySelector('#' + container.id)) {
                        currentMembershipSection.querySelector('#' + container.id).classList.remove('active');
                    } 
                })

                let membershipLevelId = '#membershipContainer' + tab.id.replace('membershipPageTab', '');

                currentMembershipSection.querySelector(membershipLevelId).classList.add('active');
            }
        })
    })

    membershipContainerTabsArray.forEach(function (tab) {
        tab.addEventListener('click', function () {
            let currentMembershipSection = tab.closest('.membership-page-container-js');
            let activeMembershipContainer = currentMembershipSection.querySelector('.membership-container.active')

            if (!(tab.classList.contains('active'))) {
                membershipContainerTabsArray.forEach(function (tab) {
                    if (activeMembershipContainer.querySelector('#' + tab.id)) {
                        activeMembershipContainer.querySelector('#' + tab.id).classList.remove('active');
                        activeMembershipContainer.querySelector('#' + tab.id).parentElement.classList.remove('active');
                    }
                })
                 
                tab.classList.add('active');
                tab.parentElement.classList.add('active');               

                membershipLevelsArray.forEach(function (level) {
                    if (activeMembershipContainer.querySelector('#' + level.id)) {
                        activeMembershipContainer.querySelector('#' + level.id).classList.remove('active')
                    }
                })

                let membershipLevelId = '#membershipLevel' + tab.id.replace('membershipContainerTab', '');

                activeMembershipContainer.querySelector(membershipLevelId).classList.add('active');
            }
        })
    })

    window.addEventListener('resize', function () {
        isMobile();
    }) 

    function isMobile() {
        if (window.innerWidth < 1025) {
            membershipLevelsArray.forEach(function (level) {          
                document.querySelector('#' + level.id).classList.add('active-on-mobile');
            })
        }
        else {
            membershipLevelsArray.forEach(function (level) {           
                document.querySelector('#' + level.id).classList.remove('active-on-mobile');             
            })
        }
    }
})


// WEBPACK FOOTER //
// ./Static/javascript/pages/membership.ts